<template>
  <div class="wrap">
      <HeaderComponent />
      <MainComponent />
  </div>
</template>

<script>

import HeaderComponent from './HeaderComponent.vue';
import MainComponent from './MainComponentV2.vue';

export default {
  components: {
    HeaderComponent,
    MainComponent
  }
};
</script>

<style>

body {
    font-family: 'Montserrat', sans-serif;
    font-size: 11px;
    margin: 0;
    padding: 0;
    color: #fff;
    background-color: #1e1e1e;
}
.wrap {
    padding: 14px;
}

</style>